export default __webpack_public_path__ + "static/media/ic_glp_custom.d8efc984.svg";